import { Link } from 'react-router-dom';

export const RefundNotice = ({ className = '' }) => (
  <div className={`border-t border-taupe/30 pt-6 ${className}`} data-testid="digital-refund-notice">
    <p className="text-matte/60 text-[13px] leading-relaxed">
      Due to the nature of digital products and the ability to access, download, view, or otherwise receive
      digital content after purchase, digital-product sales are final and non-refundable once access or
      delivery has been provided, except where otherwise required by applicable law.
    </p>
    <Link
      to="/no-refund-policy"
      className="mt-3 inline-block text-[11px] font-label tracking-widest uppercase text-matte hover:text-gold transition-colors"
      data-testid="digital-refund-policy-link"
    >
      Read the full No Refund Policy &rarr;
    </Link>
  </div>
);
